import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvent,
  useMapEvents,
  // LayersControl,
  // LayerGroup,
  // Circle,
  GeoJSON,
  // Rectangle,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./google-map.scss";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import MarkerClusterGroup from "react-leaflet-cluster";
import { useEffect, 
  // useMemo, useRef 
} from "react";
import { useState } from "react";
import "leaflet-boundary-canvas";
import geoJson from "geo-json/egypt.json";
function SetViewOnClick() {
  const map = useMapEvent("click", (e) => {
    map.setView(e.latlng, map.getZoom(), {
      animate: true,
    });
  });

  return null;
}
const redColor = { color: "red" };
const GoogleMap = ({
  geoLocationData,
  zoom,
  isGovernateSelected = true,
  defaultCenterPoint,
}) => {
  let DefaultMarkerIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [15, 20],
  });
  const [centerPoint, setCenterPoint] = useState(defaultCenterPoint);
  const [zoomPoint, setZoomPoint] = useState(zoom);
  useEffect(() => {
    if (geoLocationData && geoLocationData.length > 0) {
      if (isGovernateSelected) {
        setCenterPoint(geoLocationData[0].center);
      } else {
        setCenterPoint([27.340430049626093, 31.34857523124553]);
      }
      setZoomPoint(zoom);
    }
  }, [geoLocationData, zoom]);

  const RenderMarkers = () => {
    const map = useMapEvents({});
    map.flyTo(centerPoint, zoom);
    return geoLocationData.map(({ geoLocation, markerLocation }, index) => {
      return (
        <Marker
          key={`marker-${index}-${markerLocation}`}
          position={geoLocation}
          icon={DefaultMarkerIcon}
        >
          <Popup>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${geoLocation[0]},${geoLocation[1]}`}
              target="_blank"
              rel="noreferrer"
            >
              {markerLocation}
            </a>
          </Popup>
        </Marker>
      );
    });
  };
  // const settingEgyptCoordinates = async () => {
  //   const geoJSON = await geoJson;
  //   const osm = L.TileLayer.boundaryCanvas(
  //     "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  //     {
  //       boundary: geoJSON,
  //       attribution:
  //         '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors, UK shape <a href="https://github.com/johan/world.geo.json">johan/word.geo.json</a>',
  //     }
  //   );
  //   mapRef.current.addLayer(osm);
  //   const ukLayer = L.geoJSON(geoJSON);
  //   mapRef.current.fitBounds(ukLayer.getBounds());

  //   // mapRef.current.zoom =10;
  // };
  const setCountryFeatures = (country, layer) => {
    layer.options.fillColor = "none";
  };

  return (
    <MapContainer center={centerPoint} zoom={zoomPoint} scrollWheelZoom={true}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <GeoJSON data={geoJson.features} onEachFeature={setCountryFeatures} />

      <SetViewOnClick />

      <MarkerClusterGroup chunkedLoading>
        {geoLocationData.length > 0 && <RenderMarkers />}
      </MarkerClusterGroup>
    </MapContainer>
  );
};

export default GoogleMap;
